export const PUBLIC_ROUTE = {
  PAGE_404: '/404',
  PAGE_500: '/500',
  COMING_SOON: '/ComingSoon',
  LANDING: '/',
  WEB_STORE: '/:id',
};